/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: 1625
 * 创建日期 2021/03/09
 */
import request from 'crm/utils/request'
import {format} from 'utils'
import qs from 'qs'
import api from './api'

export async function getList(params) {
    return request(`${format(api.getList.url, {id: params.id})}?${qs.stringify(params)}`)
}
